











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {ResponseRoboCnpj} from '@/model/resource/ResponseRoboCnpj'
import {ResponseRoboCnpjCollection} from '@/model/collection/ResponseRoboCnpjCollection'
import {ListResponseRoboCnpjSchema} from '@/schema/resource/ResponseRoboCnpj/ListResponseRoboCnpjSchema'
import {CsvResponseRoboCnpjSchema} from '@/schema/resource/ResponseRoboCnpj/CsvResponseRoboCnpjSchema'

@Component
export default class ListResponseRoboCnpjView extends Mixins(MixinQueryRouter) {
  schema = new ListResponseRoboCnpjSchema()
  collection = new ResponseRoboCnpjCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ResponseRoboCnpj) {
    Helper.pushByName('editResponseRoboCnpj', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ResponseRoboCnpjCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvResponseRoboCnpj()
    new CsvResponseRoboCnpjSchema().downloadCsv(csv.all())
  }
}
